import React from 'react';

import classNames from 'classnames';

import { useBoolState } from 'common/hooks';
import { useStyles } from './styles';

import {
  Collapse,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Typography
} from 'e100-react-components';

export const ListCollapse = ({
  title,
  action,
  children,
  classes
}: ListCollapseProps) => {
  const innerClasses = useStyles();
  const [ expanded, toggleExpanded ] = useBoolState(true);

  return (
    <Card
      classes={{
        root: classNames(`${innerClasses.cardRoot} ${classes?.root || ''}`)
      }}
    >
      <CardHeader
        avatar={
          <IconButton
            kind={expanded ? 'arrowDropUp' : 'arrowDropDown'}
            onClick={toggleExpanded}
            classes={{
              button: {
                root: innerClasses.headerAvatarRoot
              }
            }}
          />
        }
        title={<Typography variant='subtitle2'>{title}</Typography>}
        action={action}
        classes={{
          root: innerClasses.cardHeaderRoot
        }}
      />
      <Collapse isIn={expanded}>
        <CardContent
          classes={{
            root: innerClasses.cardContentRoot
          }}
        >
          {children}
        </CardContent>
      </Collapse>
    </Card>
  );
};

interface Classes {
  root?: string;
}
export interface ListCollapseProps {
  title: string;
  children?: any;
  addItemTooltip?: string;
  action?: any;
  classes?: Classes;
}
